module.exports = __webpack_public_path__ + "img/product_57.e7ab2e1.svg";